import styled, { css } from 'styled-components'

type Variant = 'signup' | 'paywall'

const CHECKED_COLORS: Record<Variant, { bg: string; border: string }> = {
  signup: { bg: '#fffbeb', border: '#fbbf24' },
  paywall: { bg: '#eff2f5', border: '#ccd6e0' },
}

const cardStyles = (variant: Variant, checked: boolean) => css`
  border: 1px solid ${checked ? CHECKED_COLORS[variant].border : '#ccd6e0'};
  border-radius: 8px;
  background-color: ${checked ? CHECKED_COLORS[variant].bg : '#fff'};
  padding: 8px 16px 8px 8px;
  transition:
    background-color 0.2s,
    border-color 0.2s;
`

export const Label = styled.label<{ $variant: Variant; $checked: boolean }>(
  ({ $variant, $checked }) => css`
    display: flex;
    align-items: ${$variant === 'paywall' ? 'center' : 'flex-start'};
    gap: ${$variant === 'paywall' ? 4 : 8}px;
    width: 100%;
    cursor: pointer;
    user-select: none;
    text-align: start;

    ${$variant === 'signup' && cardStyles($variant, $checked)}
  `,
)

export const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;

  &:focus-visible + span {
    outline: 2px solid #445d74;
    outline-offset: 2px;
    border-radius: 3px;
  }
`

export const Box = styled.span`
  display: flex;
  flex-shrink: 0;
`

export const Card = styled.span<{ $checked: boolean }>(
  ({ $checked }) => css`
    ${cardStyles('paywall', $checked)};
    display: flex;
    align-items: flex-start;
    gap: 4px;
    flex: 1;
    min-width: 0;
  `,
)

export const Texts = styled.span<{ $variant: Variant }>(
  ({ $variant }) => css`
    display: flex;
    flex-direction: column;
    gap: ${$variant === 'paywall' ? 4 : 8}px;
    flex: 1;
    min-width: 0;
    font-size: ${$variant === 'paywall' ? 10 : 12}px;
    line-height: 1.3;
    color: ${$variant === 'paywall' ? '#64748b' : '#283845'};
  `,
)

export const Lead = styled.span`
  font-weight: 700;

  .hl {
    color: #b45309;
  }

  .regular {
    font-weight: 400;
  }
`

export const Hint = styled.span`
  font-weight: 400;
`

export const SideIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  margin-inline-start: 8px;
`
